export default __webpack_public_path__ + "435e51c5df6951122f9da6841b6b889a.gif";